import { Typography } from '@mui/material';

export default function CallSupport({ region }) {
  return (
    <Typography className="text-14 text-typography-secondary">
      {region !== 'canada' && 'Call Healthera Support on (+44) 020 4634 2296'}
    </Typography>
  );
}
